import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import { MissionLifecycleFragmentFragment } from "@/gql"
import MissionAction from "./MissionAction.vue"
import ActionDialog from "./ActionDialog.vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  GenerateConsultantInvoicesMutation,
  GenerateConsultantInvoicesMutationMutation,
  GenerateConsultantInvoicesMutationMutationVariables,
} from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'GenerateConsultantInvoicesAction',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
}



const { mutate } = useMutation()
const { addSuccess } = useNotification()
const isSubmitting = ref(false)

const generateInvoicesPayload = {
  title: "Generate invoices",
  description:
    "You are about to generate invoices for consultants on this mission. This will generate any missing consultant invoices post contract acceptance.",
  buttonText: "Yes, generate invoices",
}

const showGenerateInvoicesModal = ref(false)

const onConfirmGenerateInvoices = async () => {
  isSubmitting.value = true

  const result = await mutate<
    GenerateConsultantInvoicesMutationMutation,
    GenerateConsultantInvoicesMutationMutationVariables
  >({
    mutation: GenerateConsultantInvoicesMutation,
    variables: {
      missionLifecycleId: props.mission.prn,
    },
    done: () => {
      isSubmitting.value = false
    },
  })

  if (result?.data && !result?.data?.generateConsultantInvoices.error) {
    addSuccess("Invoices generated successfully")
    onCloseModal()
  }
}

const onCloseModal = () => {
  showGenerateInvoicesModal.value = false
}

return { __sfc: true,props, mutate, addSuccess, isSubmitting, generateInvoicesPayload, showGenerateInvoicesModal, onConfirmGenerateInvoices, onCloseModal, MissionAction, ActionDialog }
}

})